import "./style.css";
import { useUserInfo } from "../../../../context/user";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Copy, Eye, EyeOff, Circle } from "lucide-react";
import { Button } from "components/ui/button";
import toast from "react-hot-toast";
import { useAgentsList } from "../../../../queries/agents";
import {
  useSuperAdminSettings,
  useCheckCrmAgent,
  useCreateCrmAgent,
  useUpdateStreamingApi,
  useCreateApiKey,
  useCheckSlackConnection,
  useFetchSlackConnection,
} from "../../../../queries/integrations";

function ApiAccess() {
  const user = useUserInfo()[0];
  const activeLocation = useUserInfo()[4];
  const UpdateUser = useUserInfo()[1];
  const saveActiveLocation = useUserInfo()[5];
  const agencyData = useUserInfo()[11]
  const [showApiKey, setShowApiKey] = useState(false);
  const [apiKey, setApiKey] = useState(activeLocation?.apiKey);
  const [isModalOpen, setisModalOpen] = useState(false)
  const [Modalcontent, setModalcontent] = useState('')
  const [isToggled, setIsToggled] = useState(false);
  const [myResponder, setMyResponder] = useState();
  const [processing, setProcessing] = useState(false);
  const [userComment, setUserComment] = useState('');
  const [updatedByUser, setUpdatedByUser] = useState();
  const [preFixPrompt, setPreFixPrompt] = useState('');
  const [postFixPrompt, setPostFixPrompt] = useState('');
  const [defaultprompt, setdefaultprompt] = useState({});
  const contextuploadFilefrominput = useUserInfo()[16];
  const [thirdPartFiles, setThirdPartyFiles] = useState([]);
  const [hidebtn, setHidebtn] = useState(true);
  const userInfo = useUserInfo()[0];
  const [isCRMLoaderModal, setisCRMLoaderModal] = useState(false)


  const [assistantError, setAssistantError] = useState(false)
  const [selectedOption, setSelectedOption] = useState("");
  const [loader, setLoader] = useState(false);
  const [nangoLogin, setNangoLogin] = useState(false);

  const userActiveLocation = useUserInfo()[4];


  // Was axios.get(BASE_URL + '/super_admin_settings/') fired on mount; now
  // backed by useSuperAdminSettings. Kept as an effect (not derived) since
  // userComment stays plain editable state that checkResponder below (and
  // the textarea onChange) also write to, same as before.
  const { data: superAdminSettings } = useSuperAdminSettings();
  useEffect(() => {
    if (!superAdminSettings) return;
    const fullPrompt = `${superAdminSettings?.data?.default_prompt?.default_p1} ${superAdminSettings?.data?.default_prompt?.default_p2} ${superAdminSettings?.data?.default_prompt?.default_p3}`
    setPreFixPrompt(superAdminSettings?.data?.default_prompt?.default_p1);
    setPostFixPrompt(superAdminSettings?.data?.default_prompt?.default_p3);
    setUserComment(fullPrompt);
  }, [superAdminSettings]);

  // Was two separate axios.post(BASE_URL + '/accounts/checkcrmagent...')
  // calls hitting the same route (this one read apiKey, fetchCRMAgentStatus
  // further down read status) — one shared useCheckCrmAgent query now backs
  // both, deduped to a single request.
  const { data: crmAgentCheck, refetch: refetchCrmAgentCheck } = useCheckCrmAgent(activeLocation?.id);
  useEffect(() => {
    if (crmAgentCheck) setApiKey(crmAgentCheck?.data?.apiKey);
  }, [crmAgentCheck]);

  useEffect(() => {
    checkSlackconnection()
  }, []);

  // Was a raw axios.get(`${BASE_URL}/assistant/fetchbyuser...`) fired once on
  // mount via useEffect(..., []); now backed by the shared useAgentsList query
  // (also used by usersContext.js, integration/index.js, addwebsites/index.js
  // and uploadFiles/index.js) so a write on the Agents page invalidates this
  // dropdown too. selectionData is purely derived, matching the three
  // original states: [] while loading, [initalAssistant] on error, else the
  // full status-filtered list.
  const { data: agentsFetchData, isError: agentsFetchError } = useAgentsList(userInfo._id, userActiveLocation?.id);

  const selectionData = useMemo(() => {
    const initalAssistant = {
      assistant_name: "Brand AI",
      modal_name: "openai/gpt-4o",
      assistant_id: userActiveLocation?.assistant_id,
      status: true
    };
    if (agentsFetchError) return [initalAssistant].filter(item => item.status);
    if (!agentsFetchData) return [];
    return [initalAssistant, ...(agentsFetchData?.data || [])].filter(item => item.status);
  }, [agentsFetchData, agentsFetchError, userActiveLocation?.assistant_id]);

  const checkResponder = async () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://metaconnect.maybetech.com/api/responders',
      headers: {}
    };
    await axios.request(config)
      .then((response) => {
        const exists = response.data.find(item => item.profile_id === activeLocation.id);
        if (exists) {
          setIsToggled(exists?.status)
          setMyResponder(exists);
          setUserComment(exists?.prompt)
        } else {
          setMyResponder();
          setIsToggled(false)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    setTimeout(() => {
      checkResponder();
    }, 2000);
  }, [])


  const createApiKeyMutation = useCreateApiKey();
  const handleCreateApiKey = async (e) => {
    const payload = {
      profileid: activeLocation?.id,
    };

    let response;
    try {
      response = await createApiKeyMutation.mutateAsync(payload);
    } catch (error) {
      return;
    }
    if (response) {
      toast.success(<span>
        <b>API key regenerated</b>
        <br />
        <span>Your previous key has been invalidated.</span>
      </span>)
      UpdateUser(response.data);
      refetchCrmAgentCheck();
    }
  }


  const handleToggleVisibility = () => {
    setShowApiKey(!showApiKey);
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey).then(() => {
      alert("API key copied to clipboard");
    }, (err) => {
      console.error("Could not copy text: ", err);
    });
  };
  const [confrirmModel, SetconfrirmModel] = useState(false);
  const [regenerateModal, setRegenerateModal] = useState(false);

  const handleConfirmRegenerate = async () => {
    setRegenerateModal(false);
    await handleCreateApiKey();
  };

  const TurnOff = () => {
    updateRespondr(false)
    setIsToggled(false);
    SetconfrirmModel(false)
  }
  const saveResponder = async () => {
    setProcessing(true);
    let promptToSave = userComment;
    if (updatedByUser) {
      promptToSave = `${preFixPrompt} ${userComment} ${postFixPrompt}`
    }
    let data = JSON.stringify({
      "profile_id": activeLocation?.id,
      "status": isToggled,
      "prompt": promptToSave,
      "prompt_custom": userComment,
      "prompt_prefix": preFixPrompt,
      "assistant_id": selectedOption?.value
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://metaconnect.maybetech.com/api/responders',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };
    try {
      let res = await axios.request(config)
        .then((response) => {
          setUserComment(response?.data?.prompt)
          setMyResponder(response?.data);
          setProcessing(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("Error")
    }

  }

  const updateRespondr = async (status = true) => {
    setProcessing(true);
    let promptToSave = userComment;
    if (updatedByUser) {
      promptToSave = `${preFixPrompt} ${userComment} ${postFixPrompt}`
    }
    let data = {
      "profile_id": activeLocation?.id,
      "status": status,
      "prompt": promptToSave,
      "prompt_custom": userComment,
      "prompt_prefix": preFixPrompt,
      "id": myResponder?.id,
      "assistant_id": selectedOption?.value
    };
    setUserComment(userComment)
    setMyResponder(data);
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `https://metaconnect.maybetech.com/api/responders/${myResponder?.id}`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(data)
    };
    try {
      await axios.request(config)
        .then((response) => {
          setProcessing(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("Error")
    }

  }
  // Was its own axios.post(BASE_URL + '/accounts/checkcrmagent', ...) fired
  // on mount into local state; now just derived off the shared
  // useCheckCrmAgent query above (same route as the apiKey read).
  const isConnectedCRM = !!crmAgentCheck?.status;

  const createCrmAgentMutation = useCreateCrmAgent();
  const handleConnectWithCRMAgent = (value) => {
    setisCRMLoaderModal(true)

    const payload = {
      agency_id: agencyData._id,
      api_type: "team",
      instructions: "CRM AGENT",
      model: "openai/gpt-4o",
      name: "CRM AGENT",
      profile_id: activeLocation?.id,
      readonly: true,
      status: false,
      temperature: 0.5,
      templatename: "CRM AGENT",
      top_p: 0.8,
      type: "agency",
      locationid: agencyData?.ghl?.location_id,
      handler: value
    }

    createCrmAgentMutation.mutate(payload, {
      onSuccess: () => {
        refetchCrmAgentCheck();
        setisCRMLoaderModal(false);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  }


  const handleAssistantSelect = (selected) => {
    setSelectedOption(selected)
  }


  useEffect(() => {
    // Try to find the assistant_id match from myResponder
    const matchedAssistant = selectionData?.find(item => item?.assistant_id === myResponder?.assistant_id);

    if (matchedAssistant) {
      // If found, set the matched assistant as selected
      setSelectedOption({
        label: matchedAssistant.assistant_name,
        value: matchedAssistant.assistant_id
      });
    } else {
      // If no match, find the "Brand AI" option
      const defaultAssistant = selectionData?.find(item => item?.assistant_name === "Brand AI");
      if (defaultAssistant) {
        // If "Brand AI" is found, set it as default
        setSelectedOption({
          label: defaultAssistant.assistant_name,
          value: defaultAssistant.assistant_id
        });
      }
    }
  }, [myResponder?.assistant_id, selectionData]);
  const [isConnectedtoslack, setIsConnectedtoslack] = useState(false);
  const [assistants, setassistants] = useState([]);
  const [streamingApi, setStreamingApi] = useState(userActiveLocation?.is_streaming_Api || false);
  const [selectedAssistant, setselectedAssistant] = useState({});
  const [teamId, setTeamId] = useState('')

  const updateStreamingApiMutation = useUpdateStreamingApi();
  const handleStreamApi = async () => {
    const updatedStream = !streamingApi;
    setStreamingApi(updatedStream);
    try {
      const result = await updateStreamingApiMutation.mutateAsync({
        id: userActiveLocation.id,
        streamingApi: updatedStream,
      });

      if (result?.success) {
        saveActiveLocation(result?.data)
      } else {
        console.error('Failed to update account');
      }
    } catch (error) {
      console.error('Error updating account:', error);
    }

  }



  const checkSlackConnectionMutation = useCheckSlackConnection();
  const fetchSlackConnectionMutation = useFetchSlackConnection();
  const checkSlackconnection = async () => {
    let response;
    try {
      response = await checkSlackConnectionMutation.mutateAsync(activeLocation?.id);
    } catch (error) {
      return;
    }
    if (response?.data.connected == true) {
      setIsConnectedtoslack(true);
      fetchSlackconnection(response.data?.teams[0]?.teamId)
    }
  }
  const fetchSlackconnection = async (team_id) => {
    let response;
    try {
      response = await fetchSlackConnectionMutation.mutateAsync({ profileId: activeLocation?.id, teamId: team_id });
    } catch (error) {
      return;
    }
    if (response.success) {
      if (response.data.assistants)
        setassistants(response.data.assistants);
      const matchedRecord = response.data.assistants.find(
        (item) => item.assistant_id === response.data.selectedAssistantId
      );
      setTeamId(response.data.teamId)
      setselectedAssistant(matchedRecord);
    }
  }


  //agent listed in the dropdown
  // Same /assistant/fetchbyuser data as selectionData above (reuses the
  // already-fetched agentsFetchData/agentsFetchError instead of firing a
  // second axios.get), just rearranged/matched against the user's default
  // assistant. assistantData/asistantSelected are purely derived now: both
  // collapse to [initalAssistant]/initalAssistant while loading OR on error,
  // matching the original useState initializers + catch branch exactly.
  const initalAssistant = useMemo(() => ({
    assistant_name: "Brand AI",
    modal_name: "openai/gpt-4o",
    assistant_id: user?.assistant_id,
    status: true
  }), [user?.assistant_id]);

  const { assistantData, asistantSelected } = useMemo(() => {
    const rawList = agentsFetchData?.data;
    if (agentsFetchError || !rawList) {
      return { assistantData: [initalAssistant].filter(item => item.status), asistantSelected: initalAssistant };
    }
    let filteredResponse = rawList.filter(item => item.status && item.ui_enable);
    const match = filteredResponse.find(item => item.assistant_id === user.default_assistant);
    let rearrangedResponse = [];
    if (match) {
      rearrangedResponse = [
        { ...match, selected: true },
        initalAssistant,
        ...filteredResponse
          .filter(item => item.assistant_id !== user.default_assistant)
          .map(item => ({ ...item, selected: false })),
      ];
    } else {
      rearrangedResponse = [
        initalAssistant,
        ...filteredResponse.map(item => ({ ...item, selected: false })),
      ];
    }

    let selected = initalAssistant;
    if (agentsFetchData?.crm_agent) {
      rearrangedResponse.push({
        assistant_name: "CRM Agent",
        modal_name: "openai/gpt-4o",
        assistant_id: agentsFetchData?.crm_agent,
        status: true
      })
    } else {
      selected = rearrangedResponse[0];
    }
    return { assistantData: rearrangedResponse, asistantSelected: selected };
  }, [agentsFetchData, agentsFetchError, initalAssistant, user?.default_assistant]);
  return (
    <div className="">

      {/* <div className="!border-[#D9D9D9] rounded border p-5 mb-6">
        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
          <h2 className="py-2" style={{ fontSize: "20px", fontWeight: "bold" }}>Enable Streaming Api</h2>
          <div style={{ padding: "10px 0" }}>
            <div
              onClick={handleStreamApi}
              className={`w-14 h-8 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer transition-colors duration-300 ${streamingApi ? 'bg-blue-500' : 'bg-gray-300'
                }`}
            >
              <div
                className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ${streamingApi ? 'translate-x-6' : ''
                  }`}
              ></div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="">
        <div>
          <div className="border-b border-border pb-6 mb-6">
            <div className="page-header [&_.page-display]:text-3xl [&_.page-display]:md:text-4xl [&_.page-lede]:text-sm pb-4">
              <span className="page-eyebrow">Configure</span>
              <h1 className="page-display">
                API Access. <span className="accent block md:inline">Integrate Agents with your product.</span>
              </h1>
              <p className="page-lede">
                Access our API documentation to learn how to integrate with our services using this API key.
              </p>
            </div>
            <a
              href="https://apidocs.maybetech.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-foreground hover:underline"
            >
              View Documentation →
            </a>
          </div>

          <div className="">
            <h2 className="text-[18px] font-bold text-foreground">API Key</h2>
            <p className="pt-3 mb-3 text-muted-foreground">
              Use this API key to access our services programmatically.
            </p>
            <p className="mb-5 text-muted-foreground">
              This API key is shared across your entire account and may be used by active external integrations. Regenerating the key will immediately invalidate the existing key and may interrupt any services currently using it. Only regenerate this key if you are prepared to update all connected integrations.
            </p>

            <div className="border-border rounded border p-5 flex items-center">

              <div className="flex items-center flex-1 h-[55px] pl-4 bg-muted border-border rounded border">
                <div className="flex-1 truncate" style={{ marginRight: '20px', fontWeight: 'bold' }}>
                  {showApiKey || typeof apiKey !== 'string' ? (
                    apiKey
                  ) : (
                    Array.from(apiKey).map((_, idx) => (
                      <Circle key={idx} className="w-2 h-2 fill-current inline mx-px" />
                    ))
                  )}
                </div>

                <button type="button" aria-label="Copy API key" className="ms-2 py-2 text-muted-foreground" onClick={handleCopy}>
                  <Copy className="w-4 h-4" />
                </button>
                <button type="button" aria-label="Toggle API key visibility" className="px-2 ms-2 py-2 text-muted-foreground" onClick={handleToggleVisibility}>
                  {showApiKey ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>

              <Button className="ml-4 whitespace-nowrap" onClick={() => setRegenerateModal(true)}>Regenerate API Key</Button>
            </div>
          </div>
        </div>
      </div>

      {
        regenerateModal && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50"
            onClick={() => setRegenerateModal(false)}
          >
            <div
              className="bg-card rounded-lg shadow-lg p-6 relative w-[580px] max-w-[90%]"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="text-xl font-bold mb-3 text-foreground">Regenerate API key?</h3>
              <p className="text-muted-foreground mb-3">
                This will immediately invalidate your current API key.
              </p>
              <p className="text-muted-foreground mb-3">
                Any integrations, scripts, or external services using the existing key will stop working until updated with the new key.
              </p>
              <p className="text-muted-foreground mb-6">
                Are you sure you want to continue?
              </p>
              <div className="flex justify-end gap-3">
                <Button variant="outline" onClick={() => setRegenerateModal(false)}>Cancel</Button>
                <Button variant="destructive" onClick={handleConfirmRegenerate}>Regenerate Key</Button>
              </div>
            </div>
          </div>
        )
      }

      {

        isCRMLoaderModal &&
        <div
          className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
          onClick={() => setisCRMLoaderModal(false)}
        >
          <div
            className="bg-card rounded-lg shadow-lg p-6 relative w-96"
            onClick={(e) => e.stopPropagation()}
          >
            <p
              className="absolute top-3 right-3 text-muted-foreground cursor-pointer hover:text-foreground"
              onClick={() => setisCRMLoaderModal(false)}
            >
              X
            </p>
            <div className="text-center">
              <p className="text-lg font-medium mb-4">It Will Take Some Time</p>
              <div className="flex items-center justify-center space-x-2 mt-4">
                <span className="w-3 h-3 bg-foreground rounded-full animate-pulse"></span>
                <span className="w-3 h-3 bg-foreground rounded-full animate-pulse delay-300"></span>
                <span className="w-3 h-3 bg-foreground rounded-full animate-pulse delay-600"></span>
              </div>
            </div>
          </div>
        </div>

      }

      {
        isModalOpen && (
          <div className="modal-zz" onClick={() => setisModalOpen(false)}>
            <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
              <p
                style={{
                  position: "absolute",
                  right: 0,
                  width: "12px",
                  height: "12px",
                  cursor: "pointer",
                }}
                onClick={() => setisModalOpen(false)}
              >
                X
              </p>
              {Modalcontent == "no_session" ?
                <b>Something went wrong please refresh the page</b>
                :
                <iframe style={{ height: "80vh", width: "100%", overflow: 'scroll' }} src={Modalcontent}></iframe>
              }
            </div>
          </div>

        )
      }
      {
        confrirmModel &&
        <div className="modal-zz-confirm" onClick={() => SetconfrirmModel(false)}>

          <div className="scrollable-modal-content bg-card  rounded" style={{ border: "1px solid hsl(var(--border)) " }}>
            <p className="modalText">
              Are you sure you want to turn off Auto-reply to Facebook and Instagram comments?
            </p>
            <div className="modalBtnGroup">
              <button className="agreeBtn" onClick={TurnOff}>
                Turn off
              </button>
              <p className="disagreeBtn" onClick={() => SetconfrirmModel(false)}>
                Cancel
              </p>
            </div>
          </div>
        </div>


      }

    </div >
  );
}
export default ApiAccess;



